export const CLAUSES_OPTIONS = {
  OPTIONAL: "optional",
  FREE_TEXT: "free_text",
  MULTI_SELECT: "multi_select",
  SINGLE_SELECT: "single_select",
  PRODUCT_CATALOG_COLUMN: "product_catalog_column",
  PRICE_CATALOG_COLUMN: "price_catalog_column",
};
export const DYNAMIC_FIELD_OPTIONS = {
  ADDRESS: "textarea",
  AMOUNT: "number",
  CHECKBOX: "single_select",
  DATE: "date",
  EMAIL: "text",
  NUMBER: "number",
  PERCENT: "percent",
  PERIOD: "single_select",
  SINGLE_LINE_TEXT: "text",
  SINGLE_SELECT: "single_select",
};

export const TEMPLATE_TABS_LIST = {
  DATA_STUDIO: "DATA_STUDIO",
  TEMPLATE: "TEMPLATE",
  FIELD_INSPECTOR: "FIELD_INSPECTOR",
  ALL_DOCUMENTS: "ALL_DOCUMENTS",
};

export const CLAUSE_TYPE = [
  {
    type: CLAUSES_OPTIONS.FREE_TEXT,
    label: "Text Area",
  },
  {
    type: CLAUSES_OPTIONS.MULTI_SELECT,
    label: "Multi Select",
  },
  {
    type: CLAUSES_OPTIONS.SINGLE_SELECT,
    label: "Single Select",
  },
  {
    type: CLAUSES_OPTIONS.PRODUCT_CATALOG_COLUMN,
    label: "Product Column",
  },
  {
    type: CLAUSES_OPTIONS.PRICE_CATALOG_COLUMN,
    label: "Price Book Column",
  },
];
export const CLAUSE_TYPE_VALUE = [
  {
    type: CLAUSES_OPTIONS.FREE_TEXT,
    label: "Text Area",
  },
  {
    type: CLAUSES_OPTIONS.MULTI_SELECT,
    label: "Multi Select",
  },
  {
    type: CLAUSES_OPTIONS.SINGLE_SELECT,
    label: "Single Select",
  },
];

export const CLAUSE = "CLAUSE";
export const DYNAMIC_FIELD = "DYNAMICFIELD";

export const TEMP_FORM_FIELD_DATA = {
  tempWFCondition: {
    conditions: [],
    logicalOperator: "AND",
    showOperators: false,
  },
  tempWFAction: {
    approvers: [{}],
    approvalType: "Sequential",
    triggerMessage: "",
  },
};

export const APPROVAL_TYPE = {
  Parallel: "PARALLEL",
  Quorum: "QUORUM",
  Sequential: "SEQUENTIAL",
  Serial: "SERIAL",
  Unanimous: "UNANIMOUS",
};

export const APPROVAL_TYPE_MAP = {
  PARALLEL: "Parallel",
  QUORUM: "Quorum",
  SEQUENTIAL: "Sequential",
  SERIAL: "serial",
  UNANIMOUS: "Unanimous",
};

export const FREE_TEXT_VIEW =
  '<div className="free-text-box-placeholder">Free text box placeholder</div>';

export const TEMPLATE_STATUS_OPTIONS = [
  {
    options: [
      {
        buttontext: "Active",
      },
      {
        buttontext: "Inactive",
      },
    ],
  },
];

export const TEMPLATE_ROW_SETTINGS_OPTIONS = [
  {
    id: "rename",
    name: "Rename",
    argument: null,
    icon: ["far", "pen-square"],
    iconClassName: "icon-pen-square",
    isBottomLine: false,
  },
  {
    id: "delete",
    name: "Delete",
    argument: null,
    icon: ["far", "trash-alt"],
    iconClassName: "icon-trash-alt",
    isBottomLine: false,
  },
  {
    id: "clone",
    name: "Clone",
    argument: null,
    icon: ["far", "copy"],
    iconClassName: "icon-copy",
    isBottomLine: false,
  },
];

export const TEMPALTE_USER_GROUP_COLOR = {
  0: "#a19191",
  1: "#63c072",
  2: "#68b2ea",
  3: "#ffb6c4",
  4: "#9e65ef",
  5: "#406f08",
  6: "#0537ae",
  7: "#faff00",
  8: "#9cd326",
  9: "#427d50",
  10: "#72c9c5",
  11: "#9dacbb",
  12: "#9795ff",
  13: "#7053c9",
  14: "#0c15ff",
  15: "#ff0078",
  16: "#795449",
  17: "#e26d3f",
  18: "#fdf500",
  19: "#bea938",
  20: "#99218d",
  21: "#ff7600",
  22: "#7d8da7",
  23: "e67676",
  24: "7fffd4",
};

export const TEMPLATE_STATUSES_FOR_FILTER = {
  DRAFT: {
    label: "Draft",
    status: "DRAFT",
  },
  ACTIVE: {
    label: "Active",
    status: "ACTIVE",
  },
  DEACTIVE: {
    label: "Inactive",
    status: "DEACTIVE",
  },
};
